export const dragDropTypes = {
  CARD_CLIP: 'CardClip',
  CLIP_BOTTOM: 'ClipBottom',
};
